import { render, staticRenderFns } from "./VendedorCadastroPage.vue?vue&type=template&id=266e3fd8&"
import script from "./VendedorCadastroPage.vue?vue&type=script&lang=js&"
export * from "./VendedorCadastroPage.vue?vue&type=script&lang=js&"
import style0 from "./VendedorCadastroPage.vue?vue&type=style&index=0&id=266e3fd8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports